import React, { FC } from 'react';

const iconLamp = require('./icon_lamp.svg');

export const IconLamp: FC = () => {
  return <img src={iconLamp} width={74} height={79} alt="icon_lamp" />;
};

IconLamp.displayName = 'IconLamp';
